import React from 'react';
import { Container, IconWrapper, PressableText, Text, TextContainer } from './EmptyList.styles';

export type EmptyListProps = {
    defaultText: string;
    defaultPressableText: string;
    text?: string;
    pressableText?: string;
    onPress?: () => void;
    children?: React.ReactNode;
    backgroundColor?: string;
}

const EmptyList = ({
    defaultText,
    defaultPressableText,
    text,
    pressableText,
    onPress,
    children,
    backgroundColor,
}: EmptyListProps) => {
    return (
        <Container>
            <IconWrapper style={{ backgroundColor }}>
                <svg width="55" height="46" viewBox="0 0 55 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.6423 0C4.30292 0 0.785156 3.51776 0.785156 7.85714V44C0.785156 44.8679 1.48871 45.5714 2.35658 45.5714H5.49944C6.36732 45.5714 7.07087 44.8679 7.07087 44V9.42857C7.07087 7.69282 8.47798 6.28571 10.2137 6.28571H44.7852C46.5209 6.28571 47.928 7.69282 47.928 9.42857V44C47.928 44.8679 48.6316 45.5714 49.4994 45.5714H52.6423C53.5102 45.5714 54.2137 44.8679 54.2137 44V7.85714C54.2137 3.51776 50.696 0 46.3566 0H8.6423Z" fill="#FEFEFE"/>
                    <path d="M11.7852 12.5714C11.7852 11.7036 12.4887 11 13.3566 11H41.6423C42.5102 11 43.2137 11.7036 43.2137 12.5714V17.2857C43.2137 18.1536 42.5102 18.8571 41.6423 18.8571H13.3566C12.4887 18.8571 11.7852 18.1536 11.7852 17.2857V12.5714Z" fill="#FEFEFE"/>
                    <path d="M11.7852 23.5714C11.7852 22.7036 12.4887 22 13.3566 22H41.6423C42.5102 22 43.2137 22.7036 43.2137 23.5714V28.2857C43.2137 29.1536 42.5102 29.8571 41.6423 29.8571H13.3566C12.4887 29.8571 11.7852 29.1536 11.7852 28.2857V23.5714Z" fill="#FEFEFE"/>
                    <path d="M11.7852 34.5714C11.7852 33.7036 12.4887 33 13.3566 33H41.6423C42.5102 33 43.2137 33.7036 43.2137 34.5714V39.2857C43.2137 40.1536 42.5102 40.8571 41.6423 40.8571H13.3566C12.4887 40.8571 11.7852 39.2857V34.5714Z" fill="#FEFEFE"/>
                </svg>
            </IconWrapper>

            <TextContainer>
                {!children && onPress &&
                    <>
                        <Text>{text || defaultText}</Text>
                        <PressableText onClick={onPress}>{pressableText || defaultPressableText}</PressableText>
                    </>
                }
                {children}
            </TextContainer>
        </Container>
    );
};

export default EmptyList;
